module.exports = __webpack_public_path__ + "img/t4-i2.51f1b666.svg";